import { IconComponent } from "@vygruppen/spor-icon-react";
import type { ColorScheme } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/types";
import { FC, useMemo } from "react";
import { Semantics } from "shared/components/drops/DropsBadge";
import { semanticsToVariant } from "shared/utils/semantics";
import { Box, DropsStaticAlert, Text } from "shared/components/Spor";
import { NoteFill18Icon } from "shared/icons/NoteIcon";
import { PlanInternalMessage } from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";

const createNoteIconWithBox = (fill: string): IconComponent =>
  ((props) => (
    <Box mt="-2px">
      <NoteFill18Icon {...(props as object)} $fill={fill} />
    </Box>
  )) as IconComponent;

type InternalMessageBoxProps = {
  messages: PlanInternalMessage[];
  colorScheme: ColorScheme;
  semantics: Semantics;
};

export const InternalMessageBox: FC<InternalMessageBoxProps> = ({
  messages,
  colorScheme,
  semantics,
}) => {
  const icon = useMemo(
    () => createNoteIconWithBox(colorScheme.accentColor),
    [colorScheme.accentColor],
  );

  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <DropsStaticAlert
      variant={semanticsToVariant(semantics)}
      title="Internmelding"
      icon={icon}
      width="100%"
    >
      <Text fontWeight="normal">
        {messages[0].messages.NOB?.message ?? "Ingen beskrivelse tilgjengelig"}
      </Text>
    </DropsStaticAlert>
  );
};
